<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="编辑"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >

        <a-form-item
          label="模版名称"
          class="simiot-display-item"
        >
          {{ data.name }}
        </a-form-item>

        <a-form-item label="运营商模版CODE">
          <a-input
            v-decorator="['carrier_sms_template_code', {
              normalize: this.$lodash.trim,
              rules: [
                { max: 20, message: '最多20个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item
          label="内容"
          class="simiot-display-item"
        >
          {{ data.content }}
        </a-form-item>

        <a-form-item
          label="说明"
          class="simiot-display-item"
        >
          {{ data.remark }}
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findCarrierSmsTemplateForm, updateCarrierSmsTemplate } from '@/api/carrier_sms_template'

export default {
  name: 'EditCarrierSmsTemplate',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    carrierAccountId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'carrier_sms_template' }),
      submitting: false,
      data: {}
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    fetchFormData() {
      findCarrierSmsTemplateForm(this.id).then((res) => {
        this.data = res.data
        this.form.setFieldsValue({
          name: res.data.name,
          carrier_sms_template_code: res.data.carrier_sms_template_code,
          content: res.data.content,
          remark: res.data.remark
        })
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          const data = Object.assign({ carrier_account_id: this.carrierAccountId }, values)
          updateCarrierSmsTemplate(this.id, data).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
